import * as React from "react";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import { RouteChildrenProps } from "react-router";
import queryString from "query-string-for-all";
import Helmet from "react-helmet";

import { HeadBar } from "../../../components/Reports/Comfort/components/HeadBar";
import {
  StyledBackgroundRow,
  StyledWrap,
} from "../../../components/Reports/Reports.styles";
import { useState as useComfortState } from "../../../context/reports/comfort";
import { usePortfolioEffects } from "./hooks/usePortfolioEffects";
import { ComfortPortfolio } from "../../../components/Reports/Comfort";
import { COMFORT_PERSIST_KEY } from "../../../context/reports/comfort/constants";
import { navigate } from "../../../utils/routes/navigate";
import { useTrackedActions } from "../../../components/Reports/Comfort/hooks/useTrackedActions";
import { updateIsMultiSiteRoute } from "../../../redux/modules/_BETA/selections";
//import { useZoneEffects } from "./hooks/useZoneEffects";

interface ConnectedProps {
  appReady: boolean;
}

interface DispatchProps {
  setMultiSite: typeof updateIsMultiSiteRoute;
}

type Props = ConnectedProps & DispatchProps & RouteChildrenProps;

function mapStateToProps(state: Insite.AppState): ConnectedProps {
  return {
    appReady: state.appSetup.appSetupComplete,
  };
}

function mapDispatchToProps(dispatch: Dispatch) {
  return {
    setMultiSite: () => dispatch(updateIsMultiSiteRoute(true)),
  };
}

const Scene: React.FunctionComponent<Props> = ({
  appReady,
  history,
  setMultiSite,
}) => {
  const sites = React.useMemo(() => {
    const qs = queryString.parse(history.location.search, {
      arrayFormat: "comma",
    });
    return Array.isArray(qs.sites) ? qs.sites : ([qs.sites] as string[]);
  }, [history.location.search]);

  React.useEffect(() => {
    if (sites.length === 1) {
      navigate(`/reports/performance/comfort/${sites[0]}`)();
    } else {
      // * Update the global site select to display selected site count
      setMultiSite();
    }
  }, [sites]);

  const state = useComfortState();

  usePortfolioEffects({ appReady, sites });
  // useZoneEffects({ appReady, sites, siteId: sites[0] });

  const { trackedTimeFrame } = useTrackedActions();

  if (!appReady || sites.length === 1) {
    return null;
  }

  return (
    <React.Fragment>
      <Helmet title="Performance - Comfort" />
      <StyledBackgroundRow>
        <HeadBar
          subTitle="Comfort Performance"
          groupName="" // * TODO: Implement correct project name once single project work complete
          defaultTimeFrame={state.timeFrameOption}
          defaultCompareTo={state.compareToOption}
          onTimeFrameChange={trackedTimeFrame}
          persistKey={COMFORT_PERSIST_KEY}
        />
      </StyledBackgroundRow>
      <StyledWrap>
        <ComfortPortfolio portfolio={state.portfolio} />
      </StyledWrap>
    </React.Fragment>
  );
};

export const PortfolioScene = connect(
  mapStateToProps,
  mapDispatchToProps
)(Scene);
